import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tabs"
export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { 
    defaultTab: { type: String, default: "" },
    persistKey: { type: String, default: "" }  // Key for sessionStorage persistence
  }

  connect() {
    this.initializeTab()
  }

  initializeTab() {
    // Priority: URL hash > sessionStorage > default > first tab
    const hash = window.location.hash.replace('#', '')
    const storedTab = this.persistKeyValue ? sessionStorage.getItem(this.persistKeyValue) : null
    const initialTab = hash || storedTab || this.defaultTabValue || this.tabTargets[0]?.dataset.tabName
    
    if (initialTab) {
      this.showTab(initialTab)
    }
  }

  select(event) {
    event.preventDefault()
    const tabName = event.currentTarget.dataset.tabName
    this.showTab(tabName)
    
    // Update URL hash without scrolling
    history.replaceState(null, null, `#${tabName}`)
    
    // Persist to sessionStorage if key is provided
    if (this.persistKeyValue) {
      sessionStorage.setItem(this.persistKeyValue, tabName)
    }
  }

  showTab(tabName) {
    // Update tab buttons
    this.tabTargets.forEach(tab => {
      const isActive = tab.dataset.tabName === tabName
      tab.classList.toggle("border-indigo-500", isActive)
      tab.classList.toggle("text-indigo-600", isActive)
      tab.classList.toggle("border-transparent", !isActive)
      tab.classList.toggle("text-gray-500", !isActive)
      tab.classList.toggle("hover:border-gray-300", !isActive)
      tab.classList.toggle("hover:text-gray-700", !isActive)
      tab.setAttribute("aria-selected", isActive)
    })

    // Update panels
    this.panelTargets.forEach(panel => {
      const isActive = panel.dataset.tabName === tabName
      panel.classList.toggle("hidden", !isActive)
    })
    
    // Persist to sessionStorage if key is provided
    if (this.persistKeyValue) {
      sessionStorage.setItem(this.persistKeyValue, tabName)
    }
  }
}
